import React from 'react';
import { translations, dictionaryTranslate } from '@data/translations';
import DocumentHeader from './DocumentHeader';
import DocumentFooter from './DocumentFooter';
import InvoiceItems from '../invoicePresenter/InvoiceItems';
import { SingleReservationInvoiceHeader } from '../invoicePresenter/InvoiceHeaderView';
import InvoiceHeaderView from '../invoicePresenter/InvoiceHeaderView';
import InvoiceItemsSummary from '../invoicePresenter/InvoiceItemsSummary';
import InvoiceTaxSummary from '../invoicePresenter/InvoiceTaxSummary';
import PrintToolbar from './PrintToolbar';
import InvoiceFooter from './InvoiceFooter';
import { clearInvoicePrintPreview } from './controler';
import { NoteAndReclamation } from '../invoicePresenter/InvoiceItemsSummary';
import { getInvoicePropertiesNeededForInvoicePreview } from '../invoicePresenter/utils';
import { InvoiceItemsModel, InvoiceModelWithInvoiceItems } from '@common/modelDefinition';
import { InvoicePrintViewProps } from './PrintView';
import './style.css';
import { simplifyInvoiceItems } from '../checkout/controler';
import useStore from '@data/state/zustand';
export interface PaginateA4FrameProps extends InvoicePrintViewProps {
    page?: number;
    details?: boolean;
}
const PaginateA4Frame = (props: PaginateA4FrameProps) => {
    const {
        invoice,
        invoiceItems: invoiceItemsProps,
        invoicePreview,
        groupReservationsArray,
        location,
        details = false,
        history,
        invoiceRefId
    } = props;
    // details - prikaz pojedinačnih računa React. sklopu grupnog - neke stavke ne prikazujemo na osnovu details propsa
    const { locale } = invoice;
    const translate = (text: string) => {
        return dictionaryTranslate(text, translations[locale as keyof typeof translations]);
    };
    const [showGuestsNumber, setShowGuestNumber] = React.useState<boolean>(true);
    const [showRooms, setShowRooms] = React.useState<boolean>(true);
    const [headerHeight, setHeaderHeight] = React.useState(null as number | null);
    const [footerHeight, setFooterHeight] = React.useState(null as number | null);

const simpleViewToggle = useStore((appState: any) => appState.state.invoicePresenter.simpleViewEnabled);
    
    // null = toggle nije dirnut, koristi invoice.simpleView
    // true/false = korisnik je kliknuo, koristi toggle
    const simpleViewEnabled = simpleViewToggle !== null && simpleViewToggle !== undefined
        ? simpleViewToggle 
        : (invoice.simpleView || false);

    const rawInvoiceItems: InvoiceItemsModel[] =
        invoicePreview && invoicePreview.invoiceItems.length > 0 ? invoicePreview.invoiceItems : invoiceItemsProps;
    
    const invoiceItems: InvoiceItemsModel[] = simpleViewEnabled
        ? simplifyInvoiceItems(rawInvoiceItems, translate)
        : rawInvoiceItems;
        //A4    210 x 297 mm
    const singleReservationPreviewInvoice: InvoiceModelWithInvoiceItems | null =
        invoicePreview && invoicePreview.invoiceItems.length > 0
            ? getInvoicePropertiesNeededForInvoicePreview(invoicePreview.invoice, invoice, invoiceItems)
            : null;
    const singleReservationPreview: boolean = singleReservationPreviewInvoice !== null || details;
    const firstPageInvoiceHeader = (
        <div>
            {singleReservationPreview ? (
                <SingleReservationInvoiceHeader
                    translate={translate}
                    invoice={singleReservationPreviewInvoice ? singleReservationPreviewInvoice : invoice}
                    invoiceItems={invoiceItems}
                    showGuestsNumber={showGuestsNumber}
                    showRooms={showRooms}
                    locale={locale}
                />
            ) : (
                <InvoiceHeaderView
                    translate={translate}
                    invoice={invoice}
                    invoiceItems={invoiceItems}
                    setHTMLTitle={true}
                    showGuestsNumber={showGuestsNumber}
                    showRooms={showRooms}
                    groupReservationsArray={groupReservationsArray}
                    location={location}
                    locale={locale}
                />
            )}
        </div>
    );
    const lastPageInvoiceFooter = (
        <div>
            {invoicePreview && invoicePreview.invoiceItems.length > 0 && singleReservationPreviewInvoice ? (
                <React.Fragment>
                    <InvoiceItemsSummary
                        translate={translate}
                        invoice={singleReservationPreviewInvoice}
                        invoiceItems={invoiceItems}
                    />
                    <div className="text-center mt-4 mb-4 d-print-none">
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                                clearInvoicePrintPreview();
                            }}
                        >
                            {translate('Close')}
                        </button>
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <InvoiceItemsSummary translate={translate} invoice={invoice} invoiceItems={invoiceItems} />
                    <InvoiceTaxSummary translate={translate} invoice={invoice} invoiceItems={invoiceItems} />
                    <NoteAndReclamation translate={translate} invoice={invoice} invoiceItems={invoiceItems} />
                </React.Fragment>
            )}
            <InvoiceFooter />
        </div>
    );


    return (
        <React.Fragment>
            <div>
                <div
                    style={{ width: '900px', zIndex: 9999, margin: 'auto' }}
                    className="fixed-top bg-light pb-1 pt-1"
                >
                    <PrintToolbar
                        translate={translate}
                        invoice={invoice}
                        location={location}
                        setShowGuestNumber={setShowGuestNumber}
                        showGuestsNumber={showGuestsNumber}
                        setShowRooms={setShowRooms}
                        showRooms={showRooms}
                        history={history}
                        groupReservationsArray={groupReservationsArray}
                        invoiceRefId={invoiceRefId}
                    />
                </div>
                <div className="page-header" >
                    <DocumentHeader setHeaderHeight={setHeaderHeight}/>
                </div>
                <div className="page-footer" >
                    <DocumentFooter  setFooterHeight={setFooterHeight}/>
                </div>
                <table style={{ width: `${900}px` }}>
                    <thead>
                        <tr>
                            <td>
                                <div style={{ height: `${headerHeight}px` }}></div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="page bg-white pr-1 pl-1">
                                    {firstPageInvoiceHeader}
                                    <InvoiceItems
                                        invoiceItems={invoiceItems}
                                        invoice={invoice}
                                        translate={translate}
                                        print={true}
                                    />
                                    {lastPageInvoiceFooter}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <div style={{ height: `${footerHeight}px` }}></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </React.Fragment>
    );
};
export default PaginateA4Frame;